import React from 'react';
import './Features.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faBuilding, faTools, faArrowUpFromBracket } from '@fortawesome/free-solid-svg-icons';

function Features() {
  return (
    <section className="features-section">
      <div className="container">
        <h2>SOLUCIONES REALES PARA PANADERÍAS</h2>
        <p className="subtitle">Aumenta tu producción y reduce el tiempo de trabajo. Ideal para panaderías</p>
        <div className="feature-cards">
          <div className="feature-card">
            <div className="icon-wrapper">
              <FontAwesomeIcon icon={faChartLine} size="3x" />
            </div>
            <h3>Producción eficiente</h3>
            <p>Aumenta tu producción y reduce el tiempo de trabajo.</p>
          </div>
          <div className="feature-card">
            <div className="icon-wrapper">
              <FontAwesomeIcon icon={faBuilding} size="3x" />
            </div>
            <h3>Construcción robusta</h3>
            <p>Equipos fabricados en acero de alta resistencia, diseñados para el uso intensivo diario.</p>
          </div>
          <div className="feature-card">
            <div className="icon-wrapper">
              <FontAwesomeIcon icon={faTools} size="3x" />
            </div>
            <h3>Servicio técnico</h3>
            <p>Soporte técnico directo con repuestos disponibles en todo el país.</p>
          </div>
          <div className="feature-card">
            <div className="icon-wrapper">
              <FontAwesomeIcon icon={faArrowUpFromBracket} size="3x" />
            </div>
            <h3>Escalabilidad</h3>
            <p>Soluciones para panaderías de todos los tamaños, desde emprendimientos hasta grandes plantas de producción.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;